import angular from 'angular';
import { DrugDepletionsInteractionsComponent } from './drug-depletions-interactions.component';
export var DrugDepletionsInteractions = angular
    .module('eeComUiApp.drugDepletionsInteractions', [])
    .component('drugDepletionsInteractions', DrugDepletionsInteractionsComponent)
    .name;
//# sourceMappingURL=drug-depletions-interactions.module.js.map